module.exports = __webpack_public_path__ + "img/refer_sidemenu_black.651c664a.svg";